import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import {
  getSessionLandingPath,
} from '../config/sessionAppData';
import {
  SALON_APP_SESSION_TOKEN_KEY,
} from '../config/salonApp';

const STORAGE_KEY = SALON_APP_SESSION_TOKEN_KEY;

const SkinSessionContext = createContext(null);

export function SkinSessionProvider({ children }) {
  const [token, setTokenState] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch {
      return '';
    }
  });

  const setToken = useCallback((value) => {
    const next = typeof value === 'string' ? value : '';
    setTokenState(next);
    try {
      if (next) {
        sessionStorage.setItem(STORAGE_KEY, next);
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (_) {}
  }, []);

  const sessionLandingPath = useMemo(() => getSessionLandingPath(token), [token]);

  return (
    <SkinSessionContext.Provider value={{ token, setToken, sessionLandingPath }}>
      {children}
    </SkinSessionContext.Provider>
  );
}

export function useSkinSession() {
  const ctx = useContext(SkinSessionContext);
  if (!ctx) {
    throw new Error('useSkinSession must be used within SkinSessionProvider');
  }
  return ctx;
}
